<template lang="pug">
.org-search
	Loader(v-if="!loaded")
	.org-search__inner(v-else)
		//- Below not needed per Andy - 10/20/22 (remove if decision is final)
		//- .org-search__media
			img.org-search__img(:src="imgPath", alt="Placeholder alt text")
			p.org-search__intro Worker's Compensation
		.org-search__main
			h3.org-search__heading Workers' Compensation First Report of Injury
			SearchForm(
				v-if="!!orgList.length",
				:orgList="orgList",
				:userDistrictId="userDistrictId"
			)
			p.org-list__error(v-else) There was an error loading organizations.
</template>

<script>
import Loader from "./components/Loader";
import SearchForm from "./components/SearchForm";

export default {
	name: "OrganizationSearchApp",
	components: {
		SearchForm,
		Loader,
	},
	data() {
		return {
			// imgPath: null,
			endpoint: null,
			userDistrictId: null,
			loaded: false,
			orgList: [],
		};
	},
	computed: {},
	methods: {
		async getLinkData() {
			const req = new Request(this.endpoint);
			fetch(req)
				.then((res) => {
					if (!res.ok) {
						throw new Error(`HTTP error! Status: ${res.status}`);
					} else {
						return res.json();
					}
				})
				.then((data) => {
					// console.log(data)
					this.orgList = data.data;
					// console.log(this.orgList);
					this.loaded = true;
				});
		},
		getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i <ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return false;
		},
	},
	async created() {
		this.endpoint = this.$root.apiEndpoint;
		this.userDistrictId = this.getCookie("currentDistrictId") ? this.getCookie("currentDistrictId") : null;
		await this.getLinkData();

		// Below not needed per Andy - 10/20/22 (remove if decision is final)
		// if (!!this.$root.imgPath) this.imgPath = this.$root.imgPath;
		// else this.imgPath = "/img/template-images/tasb-logo_header.svg";
	},
};
</script>


<style scoped lang="scss">
.org-search {
	min-height: 120px;
	width: 100%;
	max-width: 900px;
	position: relative;
	margin: 0 auto;
	&__inner {
		display: flex;
		border: solid 1px $medLightGray;
		border-radius: 12px;
		gap: 2.25rem;
		align-items: center;
		padding: 2.5rem;
		justify-content: center;
		@include mqdn(lg_dn) {
			flex-wrap: wrap;
		}
		@include mqdn(md_dn) {
			flex-direction: column;
			padding: 1.75rem 1rem;
		}
	}
	&__media {
		text-align: center;
	}
	&__img {
		display: block;
		margin: 0 auto;
		margin-bottom: 0.5rem;
		width: 100%;
		max-width: 280px;
		height: auto;
		max-height: 150px;
		object-fit: contain;
	}
	&__heading {
		margin-bottom: 1.125rem;
	}
	&__intro {
		margin-bottom: 0;
		font-size: 1.125rem;
	}
	&__main {
		align-self: stretch;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
}
</style>